import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {Button, Form, Toast, ToastBody} from "react-bootstrap";
import {IFile} from "../../../store/sliceFiles";
import {fetchDeletePublicLinkFile, fetchFilesByPublicLink, fetchUpdatePublicLink} from "../../../fetch/PublicLinks";
import {Copy, Trash3} from "react-bootstrap-icons";
import {LinkComponentContainer, LinkComponentLink, LinkComponentListGroup} from "./LinkComponentStyle";
import {config} from "../../../config";
import {Clipboard} from "ts-clipboard";
import {ILinks} from "../PageSettings";

interface ILinkComponentProps {
    link: ILinks
    onDel: () => void
}

const LinkComponent: FC<ILinkComponentProps> = ({link, onDel}) => {

    const [show, setShow] = useState(false)
    const [files, setFiles] = useState<IFile[]>([])

    const [enable, setEnable] = useState<boolean>(false)

    useEffect(() => {
        if (link.enable) {
            setEnable(link.enable)
        }
    },[link.enable])

    const open = useCallback(() => {
        setShow(!show)
        if (!show) {
            fetchFilesByPublicLink(link.name).then(resp => {
                if (resp.status === 200) {
                    setFiles(resp.data)
                }
            })
        }
    }, [link.name, show])


    const deleteFileLink = useCallback((name: string, id: number) => {
        fetchDeletePublicLinkFile(name, id).then(resp => {
            if (resp.status === 204) {
                fetchFilesByPublicLink(name).then(resp => {
                    if (resp.status === 200) {
                        setFiles(resp.data)
                    }
                })
            }
        })
    }, [])


    const enableLink = useCallback((name: string) => {
        fetchUpdatePublicLink(name, !enable).then(resp => {
            if (resp.status === 200) {
                setEnable(!enable)
            }
        })
    }, [link.enable, enable])


    return (
        <LinkComponentContainer>
            <LinkComponentLink>
                <Copy onClick={() => Clipboard.copy(`${config.url}/public/files/${link.name}`)}/>
                <Form.Check // prettier-ignore
                    checked={enable}
                    type={"checkbox"}
                    onChange={() => enableLink(link.name)}
                />
                <Button style={{padding: 0}} variant={"link"} onClick={open}>
                    /{link.name}
                </Button>
                <Trash3 color={"red"} onClick={onDel}/>
            </LinkComponentLink>
            <Toast show={show} style={{maxWidth: "600px", width: "100%"}}>
                <ToastBody>
                    {files.length === 0 && <span>Файлов не найдено</span>}
                    {files.length > 0 && files.map((file) => {
                        return <LinkComponentListGroup>
                                <p>{file.name}.{file.type}</p>
                                <Trash3 color={"red"} onClick={() => deleteFileLink(link.name, file.id)}/>
                        </LinkComponentListGroup>
                    })}
                </ToastBody>
            </Toast>
        </LinkComponentContainer>
    )
}
export default memo(LinkComponent)
